import { createUseStyles } from "react-jss";

export const ManagementIncidenceTypesListColumnStyle = createUseStyles((theme: any) => ({
    header: {
        display: "flex",
        gap: 5,
    },
    sort: {
        marginTop: "5px",
    },
    iconSort: {
        fill: theme.colors.iconSort.disabled,
        width: "16px",
    },
    iconSorted: {
        fill: theme.colors.iconSort.enabled,
        width: "16px",
    },
    sortColumn: {
        width: 14,
        display: "flex",
        position: "absolute",
    },
    buttonsContainer: {
        display: "flex",
    },
  
}));
